import Logo from "../../Components/Logo";
import styles from "./index.module.css";
import { Greetings } from "./Greetings";
import { useContext, useEffect, useState } from "react";
import UserTest from "./UserTest";
import UserContext from "../../store/UserStore/context";
import { useNavigate } from "react-router-dom";

export default function Test() {
  const [start, setStart] = useState(false);
  const context = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!context.store.user) navigate("/");
  }, [context.store.user, navigate]);

  useEffect(() => {
    document.body.style.padding = "0";
    document.body.style.backgroundColor = "#0A2294";
    return () => {
      document.body.style.padding = "0";
      document.body.style.backgroundColor = "#EAF0F1";
    };
  }, [start]);

  return (
    <div className={styles.container}>
      <Logo white />
      <div className={styles.content}>
        <div
          className={[
            styles.greetings,
            start ? styles.start : styles.intro,
          ].join(" ")}
        >
          {!start ? <Greetings setStart={setStart} /> : <UserTest />}
        </div>
      </div>
    </div>
  );
}
